import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { dasa } from '../../classess/dasaClasses';
import { commonService } from 'src/app/services/common.service';
import { elementAt } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-whitelevel',
  templateUrl: './whitelevel.component.html',
  styleUrls: ['./whitelevel.component.scss']
})
export class WhitelevelComponent implements OnInit {

  businessId:any;
  requestObject: dasa.RequestObject = new dasa.RequestObject();

  constructor(private activeRoute:ActivatedRoute,private router:Router,private commonService_servive: commonService,private http: HttpClient,) { }

  ngOnInit(): void {
    //const id = Number(this.activeRoute.snapshot.paramMap.get('businessId'));
    this.activeRoute.queryParams.subscribe(params =>{
      this.businessId = params['businessId'];
    })
    this.getBuisnessByID();
  }

  async getBuisnessByID()
  {
    this.requestObject.businessId = parseInt(this.businessId);
    this.requestObject.command = dasa.Constant.ACTION_TYPE_GET_BUSINESS_BY_ID;
    // console.log('Input response data', this.requestObject)    
    //dasa.Utility.showBusy();

    try {
      this.http.get(environment.NEW_BACKEND_URL + 'api/business/getBusiness/'+this.businessId)
        .subscribe((res: any) => {
          // console.log(res.data)
          if(res.success){
            dasa.Utility.business = res.data 
            this.router.navigate(['/']);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }

  }
}
